import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { pageHeaderSx, primaryButtonSx } from '../../styles/tokens';

/**
 * Consistent page header: title, subtitle, optional action button or custom actions slot.
 */
const PageHeader = ({
  title,
  subtitle,
  actionLabel,
  actionIcon,
  onAction,
  actionProps = {},
  actions,
}) => (
  <Box sx={pageHeaderSx}>
    <Box sx={{ minWidth: 0, pt: 0.5 }}>
      <Typography
        sx={{
          fontSize: { xs: '1.375rem', sm: '1.5rem' },
          fontWeight: 700,
          color: 'text.primary',
          letterSpacing: '-0.025em',
          lineHeight: 1.25,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', mt: 0.75, lineHeight: 1.5, maxWidth: 520 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions || (actionLabel && onAction ? (
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={actionIcon}
        onClick={onAction}
        sx={primaryButtonSx}
        {...actionProps}
      >
        {actionLabel}
      </Button>
    ) : null)}
  </Box>
);

export default PageHeader;
